import { useContext, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useWindowSize } from "usehooks-ts";

import Sidebar from "../components/sidebar/Sidebar";
import TopNav from "../components/topnav/TopNav";

import SidebarContext from "../store/sidebarContext";
import classes from "./MainLayout.module.scss";

const MainLayout = () => {
  const sidebarCtx = useContext(SidebarContext);
  const { width } = useWindowSize();

  useEffect(() => {
    if (document.body.classList.contains("sidebar__open"))
      document.body.classList.remove("sidebar__open");
  }, []);

  useEffect(() => {
    if (width > 768 && document.body.classList.contains("sidebar__open")) {
      document.body.classList.remove("sidebar__open");
    }
  }, [width]);

  return (
    <div className={classes.container}>
      <Sidebar />
      <div
        className={`${classes.main} ${
          !sidebarCtx.isOpen ? classes.mainCollapsed : ""
        }`}
      >
        <div
          className={`${classes.main__content} main_wrapper`}
        >
          <TopNav />
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
